<template>
    <div class="desktop" v-bind="$attrs">
        <div class="nav-dropdown"
             @mouseenter="openMenu"
             @mouseleave="closeMenuWithDelay">
            <div class="nav-dropdown-button">
                {{ title }}
            </div>

            <div v-show="isOpen" class="nav-dropdown-submenu">
                <router-link 
                    v-for="(item, index) in items"
                    :key="item.title"
                    :to="item.link"
                    class="nav-dropdown-submenu-item">
                    {{ item.title }}
                </router-link>
            </div>
        </div>
    </div>

    <div class="mobile">
        <div class="nav-dropdown" @click="toggleMenu">
            <div class="nav-dropdown-button">
                {{ title }}
            </div>

            <div class="nav-dropdown-submenu" v-if="isOpen">
                <router-link 
                    v-for="(item, index) in items"
                    :key="item.title"
                    :to="item.link"
                    class="nav-dropdown-submenu-item">
                    {{ item.title }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        items: Array
    },

    data() {
        return {
            isOpen: false,
            closeTimeout: null
        }
    },

    methods: {
        openMenu() {
            if (this.closeTimeout) {
                clearTimeout(this.closeTimeout);
            }
            this.isOpen = true;
        },
        closeMenuWithDelay() {
            this.closeTimeout = setTimeout(() => {
                this.isOpen = false;
            }, 150); // Small delay of 150ms
        },
        toggleMenu() {
            this.isOpen = !this.isOpen;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/_shared.scss";

.mobile {
    display: none;
}

.nav-dropdown {
    position: relative;
    height: 100%;
}

.nav-dropdown-button {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    cursor: pointer;
    padding: 12px 30px;
    transition: all 0.2s ease;
    border-radius: 30px;
    font-size: 16px;
    text-align: center;
}

.nav-dropdown-submenu {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    min-width: 220px;
    background-color: #1a2b3c;
    border-radius: 8px;
    padding: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    margin-top: 8px;

    &::before {
        content: '';
        position: absolute;
        top: -6px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 6px solid #1a2b3c;
    }
}

.nav-dropdown-submenu-item {
    display: block;
    padding: 10px 16px;
    color: white !important;
    text-decoration: none;
    border-radius: 6px;
    transition: all 0.2s ease;
    white-space: normal;
    overflow-wrap: anywhere;
    
    &:hover {
        background-color: #006272;
        color: white !important;
        transform: translateY(-2px);
    }

    & + & {
        margin-top: 2px;
    }
}

.desktop.nav-item:hover .nav-dropdown-button,
.desktop.nav-item.active .nav-dropdown-button {
    background-color: #006272;
    color: white !important;
    text-shadow: 0 -1px 0 #006272;
    border-radius: 30px;
}

.desktop.nav-item:active .nav-dropdown-button {
    transform: translateY(4px);
}

@media only screen and (max-width: 900px) {
    .desktop {
        display: none;
    }

    .mobile {
        display: block;
        width: 100%;
    }

    .mobile .nav-dropdown {
        width: 100%;
    }

    .mobile .nav-dropdown-button {
        width: 100%;
        min-height: 40px;
        font-size: 14px;
        padding: 8px 12px;
        background: rgba(255, 255, 255, 0.06);
    }

    .nav-dropdown-submenu {
        position: static;
        transform: none;
        left: auto;
        top: auto;
        min-width: 100%;
        margin-top: 6px;
        
        &-item {
            padding: 8px 12px;
            font-size: 14px;
        }

        &::before {
            display: none;
        }
    }
}
</style>